"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createD2CMessage = void 0;
const effect_1 = require("effect");
const message_1 = require("./message");
const createD2CMessage = (namespace, events) => {
    return (0, message_1.createMessage)('event', effect_1.Schema.Union(...events)).annotations({
        identifier: `${namespace}.EventD2CMessage`,
        title: 'Event Message',
        description: 'A Device-To-Cloud message on the "event" channel',
    });
};
exports.createD2CMessage = createD2CMessage;
//# sourceMappingURL=event.js.map